import type { ReactNode } from 'react';
import { Button, Callout } from '@humanforce/mango-ui-react';
import { Flyout } from '../../../components/ui';

// Right-side flyout used to edit Person-layer sections (Person Details, Contacts, Address) per
// RR-Worker-Profile-V2 and the PRR-58 ticket ("edited via the right-side flyout").
//
// Thin adapter over the shared `components/ui/Flyout` (which owns the overlay, focus trap, scroll
// lock, Escape-to-close and focus restoration). This component only adds the save/cancel footer
// and the top-of-body error banner specific to the worker edit forms.
interface WorkerDrawerProps {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  onSave?: () => void;
  saving?: boolean;
  saveLabel?: string;
  saveDisabled?: boolean;
  /** Top-of-body error banner (e.g. a backend business-rule 409 message). */
  error?: string;
  children: ReactNode;
}

export const WorkerDrawer = ({ open, title, subtitle, onClose, onSave, saving, saveLabel = 'Save', saveDisabled, error, children }: WorkerDrawerProps) => (
  <Flyout
    open={open}
    heading={title}
    subtitle={subtitle}
    onClose={onClose}
    maxWidth="32rem"
    footer={onSave && (
      <>
        <Button variant="secondary" label="Cancel" onClick={onClose} />
        <Button variant="primary" label={saveLabel} loading={saving} disabled={saveDisabled} onClick={onSave} />
      </>
    )}
  >
    <div className="mgo-stack mgo-gap-l">
      {error && <Callout tone="critical" title="Could not save">{error}</Callout>}
      {children}
    </div>
  </Flyout>
);
